<template>
  <div class="diadin">

    <div class="title">
      
       <div>
           <el-button type="primary" @click="up">{{ $t('menu.tianjiacheliang') }}</el-button>
            <el-button type="primary" @click="upa">{{ $t('menu.piliangtianjial') }}</el-button>
        </div>
      


    </div>


  
    <el-table  empty-text=" " :row-class-name="billTableRowClassName" :data="mation" style="width: 100%" stripe border highlight-current-row>
      <el-table-column prop="mcSeriesModel" :label="$t('menu.Vehicle')" >
       <template slot-scope="scope">
          {{ motosale(scope.row.mcSeriesModel) }}
        </template>
      </el-table-column>
      <el-table-column prop="vin" :label="$t('menu.chejiahao')" > </el-table-column>
      <el-table-column prop="currentWarrantyExpiry" :formatter="formatters" :label="$t('menu.dangqzhibdaoqihijian')" >  </el-table-column>
      <el-table-column prop="extendedWarrantyYear" :label="$t('menu.yanchangqixian')" >
        <template slot-scope="scope">
       
           <el-select v-model="scope.row.extendedWarrantyYear" :placeholder="$t('menu.yanchangqixian')">
             <el-option :label="$t('menu.yinian')" value="1"> </el-option>
             <el-option :label="$t('menu.liangnian')" value="2"> </el-option>
             <el-option :label="$t('menu.sannian')" value="3"> </el-option>
             <el-option :label="$t('menu.sinian')" value="4"> </el-option>
             <el-option :label="$t('menu.wunian')" value="5"> </el-option>
            </el-select>
        </template>
        </el-table-column> 
     
      <el-table-column prop="extendedWarrantyExpiry" :label="$t('menu.ychdqsj')" >
         <template slot-scope="scope">
          {{ mots(scope.row.currentWarrantyExpiry,scope.$index) }}
        </template>
       </el-table-column>
      <el-table-column prop="imageData" :label="$t('menu.yczbpoz')" >
       

          <template slot-scope="scope">
         <el-upload action="#" class="upload-demo" :http-request="uploadFile" :before-upload="dee(scope)" :show-file-list="false" >
          <el-button size="small" plain>{{$t('menu.fbwdsc')}}</el-button>
        </el-upload>
        <div class="demo-image__preview">
          <div class="im" v-for="(item,index) in scope.row.imageData" :key="index">
           <span>{{ item.name }}</span>
            <i class="el-icon-circle-close iconB" @click="deleteImg(item,scope)" ></i>
          </div>
        </div>
        
        </template>
      </el-table-column>
      <el-table-column prop="noticeTitle" :label="$t('menu.Operation')">
        <template slot-scope="scope">
           <el-button type="text" size="mini" @click="dele(scope.$index)" >{{ $t('menu.Delete') }}</el-button>
       
        </template>
      </el-table-column>
    </el-table>
   <div>
    {{ $t('menu.cheliangzongsshu') }}: {{matioonleng  }}
   </div> 
   <div>
      <el-button type="primary" @click="updata()">{{ $t('menu.Submitsuopei') }}</el-button>
   </div>
    <el-dialog
      :title="$t('menu.tianjiacheliang')"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :before-close="handleClose">
             <div style="display: flex;"> 
              <el-input
                :placeholder="$t('menu.chejiahao')"
                v-model="sek">
              </el-input>
            
        <el-select v-model="smo" :placeholder="$t('menu.VehicleModel')" clearable>
          <el-option v-for="(item, index) in cartypelist" :key="index" 
            :label="item.dictLabel " :value="item.dictValue"></el-option>
        </el-select>
        
       
          <el-button style="margin-left: 10px;" type="primary" @click="getList()"> {{ $t('menu.sousuo') }} </el-button>
        </div>
        <el-table  empty-text=" " :row-class-name="billTableRowClassName"  @selection-change="handleCurrentChange" :data="mationli" style="width: 100%;margin-top: 15px;" height="400" stripe border >
              <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column prop="mcSeriesModel" :label="$t('menu.VehicleModel')" >
       <template slot-scope="scope">
          {{ motosale(scope.row.mcSeriesModel) }}
        </template>
      </el-table-column>
      <el-table-column prop="chassisNumber" :label="$t('menu.chejiahao')" > </el-table-column>
      <el-table-column prop="warrantyExpiry"  :label="$t('menu.dangqzhibdaoqihijian')" >  </el-table-column>
     
      
    </el-table>
        
       <!-- <el-input v-model="vin" placeholder="输入车架号"></el-input> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()"> {{ $t('menu.Cancel') }}  </el-button>
        <el-button type="primary" @click="qedx()">{{ $t('menu.Confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('menu.tianjiacheliang')"
      :visible.sync="dialogVisiblea"
      width="30%"
      :before-close="handleClose">
      <el-input
        type="textarea"
        :rows="8"
        :placeholder="$t('menu.huruduochejiahaotihsi')"
        v-model="vins">
       </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">{{ $t('menu.Cancel') }}  </el-button>
        <el-button type="primary" @click="biaoa()">{{ $t('menu.Confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mcVehicleOfDealerLista,querytype,upwoOfDealer,upload,mcVehicleOfDealerList } from "../../api/api";
export default {
  data () {
    return {
      cartypelist:[],
     vaule:'',
      id:'',
      dialogVisible: false,
      dialogVisiblea: false,
    
      action: '5',
      inle: 'zh',
      vin:'',
      vins:'',
      mation: [], //列表
      formInline: {
        orderNumber: "",
        status: "",
        applyingDealerId: "",
      },
    dcindex:0,
     vinac:'',
   matioonleng:0,
   mationli:[],
   sek:'',
   cv:[],
   smo:'',
    };
  },
  created () {
    // this.biao();
    this.getQuerytype()
    let a = sessionStorage.getItem('i18n')
    this.inle = a
     this.vinac=this.$route.query.vin
     console.log(1111,this.vinac);
     if(this.vinac!==undefined){
      console.log(2);
        this.biaocc()
     }
     
  },
 
  
  methods: {
    qedx(){
      console.log(this.cv);
      this.cv.forEach(e=>{
        this.vin = e.chassisNumber
      this.biao()
      })
      
    },
     handleCurrentChange(val) {
      this.cv=val
        console.log(val);
        
      },
    //查询车辆列表
    getList () {
      let a = sessionStorage.getItem('platform')
      let params = 'searchValue=' + this.sek + '&pageNum=1&pageSize=100&dealerId='+sessionStorage.getItem('userId')+'&mcSeriesModel='+this.smo+'&status=Registered'
      if(a==2){
         params = 'searchValue=' + this.sek + '&pageNum=1&pageSize=100&retailerId='+sessionStorage.getItem('userId')+'&mcSeriesModel='+this.smo+'&status=Registered'
      
      }
      mcVehicleOfDealerList(params).then(res => {
        if (res.data.code == 200) {
          this.mationli = res.data.rows
          
        }
      })
    },
      async biaocc () {
      let params = 'searchValue=' + this.vinac
      mcVehicleOfDealerLista(params).then(res => {
        if (res.data.code == 200) {
          if(res.data.total==0){
             this.$message({
            message: '未查询到车辆',
             type: 'error'
            });
            return false
          }
           if(res.data.rows[0].warrantyExpiry==null){
             this.$message({
            message: '该车辆未售出',
             type: 'error'
            });
            return false
          }
          let e =res.data.rows[0]
          let a ={
            mcSeriesModel:e.mcSeriesModel,
            vin:e.chassisNumber,
            currentWarrantyExpiry:e.warrantyExpiry,
            //  currentWarrantyExpiry:'2022-10-18 00:00:00',
          
            extendedWarrantyYear:'',//延长年限
            extendedWarrantyExpiry:'',//延长后年限
            imageData:[],//延长年限
            delFlag:'0'

          }
          this.mation.push(a)
             this.vin=''
           this.dialogVisible=false
            this.$message({
            message: '添加完成',
            duration:'1000'
            });
        }else{
           this.$message({
              message: 'tian',
             type: 'error'
           });
        }
      })
    
    },
    dee(e){
       console.log(e.$index);
       this.dcindex=e.$index
    },
     uploadFile(file){
     
      
      let formdata = new FormData()   //H84PDTPA0N0000003
      formdata.append('file',file.file)
      formdata.append('category',file.file.type)
      upload(formdata).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('上传成功')
          let a ={ 
            name:file.file.name,
            url:res.data.data
          }
          this.mation[this.dcindex].imageData.push(a)
          console.log( this.mation);
          
        } else {
          this.$message.error('上传失败')
        }
      })
    },
      deleteImg(e,i){
        console.log(i);
        this.dcindex=i.$index
       console.log( 123,this.vins,this.mation);
   
       this.mation[this.dcindex].imageData =  this.mation[this.dcindex].imageData.filter(m=>m != e)
    },
    //提交
      updata(){
        let data = {
          applyingCount:this.mation.length,
          woParts:[]
        }
        let  vv =  []
        vv=(JSON.parse(JSON.stringify(this.mation)))
        vv.forEach((e,i)=>{
            
          if(e.delFlag=='0'){
        
            // if(e.currentWarrantyExpiry.length>1){  00:00:00
              vv[i].extendedWarrantyExpiry = vv[i].extendedWarrantyExpiry+' 00:00:00'
            // }
            e.imageData=JSON.stringify(e.imageData)
            data.woParts.push(e)
          }
        })
        // let ac =data.woParts
        // let dc =[]
        // ac.forEach(e=>{
        //   e.imageData=JSON.stringify(e.imageData)
        //   dc.push(e)
        // })
        // data.woParts=dc
        console.log(data,this.mation);
        
          upwoOfDealer(data).then(res=>{
   
        
        if(res.data.code == 200){
          sessionStorage.setItem('name','延长质保')
           this.$router.push('/Guarantee')
        } else {
          this.$message.error(res.data.msg)
        }
      })
      
      },
    //车型
     getQuerytype () {
      const params = new URLSearchParams()
      querytype( params, 't_mc_series_model').then(r => {
        console.log(r);
        this.cartypelist = r.data.data;
      
      })
    },
      formatters(row, column, cellValue, index){
      if(cellValue != null && cellValue !=''){
        return cellValue.split(' ')[0]
      } else {
        return cellValue
      }
    },
     motosale (e) {
      let a = this.cartypelist
      let b =''
      if(e!==null){
        a.forEach(z=>{
          if(z.dictValue == e){

            b= this.iszh=='zh'?z.dictLabel:z.dictLabelEn
          }
        })
      }
      return b
    },
    mots(e,i){
       
      let a =''
      if(e != null && e !=''&&this.mation[i].extendedWarrantyYear!==''){
       let c = e.split(' ')[0]
        let arr = c.split("-")
       arr[0]= Number(arr[0])+Number(this.mation[i].extendedWarrantyYear)
        a = arr[0]+'-'+arr[1]+'-'+arr[2]
        this.mation[i].extendedWarrantyExpiry=a+' 00:00:00'
      }
      return a 
    },
    handleClose(done) {
       this.dialogVisible=false
       this.vin=''
       this.dialogVisiblea=false
       this.vins=''
      },
    up(){
        this.dialogVisible=true
        this.sek=''
        this.cv={}
        this.getList()
      },
    upa(){
        this.dialogVisiblea=true
     
      },
    async biao () {
      let params = 'searchValue=' + this.vin
      let a =1
      let b = 0
      console.log(123,this.mation);
      
      this.mation.forEach((e,i)=>{
        if(e.vin==this.vin){
           
         
            if(e.delFlag==1){
              b=i
              a=3
            }else{
                a=2
            }
         
        }
      })
      if(a==2){
        
        
         this.$message({
            message: '请勿重复添加车架号：'+this.vin,
             type: 'error'
            });
         return false
      }
      if(a==3){
          this.mation[b].imageData=[]
           this.mation[b].delFlag=0

            this.vin=''
           this.dialogVisible=false
            this.$message({
            message: '添加完成',
             duration:'1000'
            });
                let aac =this.mation
        this.matioonleng=0
        aac.forEach(e=>{
          if(e.delFlag!=='1'){
             this.matioonleng++
          }
        })
            return false
      }
      mcVehicleOfDealerLista(params).then(res => {
        if (res.data.code == 200) {
          if(res.data.total==0){
             this.$message({
            message: '未查询到车辆',
             type: 'error'
            });
            return false
          }
            if(res.data.rows[0].warrantyExpiry==null){
             this.$message({
            message: '该车辆未售出',
             type: 'error'
            });
            return false
          }
          let e =res.data.rows[0]
          let a ={
            mcSeriesModel:e.mcSeriesModel,
            vin:e.chassisNumber,
            currentWarrantyExpiry:e.warrantyExpiry,
            //  currentWarrantyExpiry:'2022-10-18 00:00:00',
          
            extendedWarrantyYear:'',//延长年限
            extendedWarrantyExpiry:'',//延长后年限
            imageData:[],//延长年限
            delFlag:'0'

          }
          this.mation.push(a)
             this.vin=''
           this.dialogVisible=false
            this.$message({
            message: '添加完成',
             duration:'1000'
            });
                let aac =this.mation
        this.matioonleng=0
        aac.forEach(e=>{
          if(e.delFlag!=='1'){
             this.matioonleng++
          }
        })
        }else{
           this.$message({
              message: 'tian',
             type: 'error'
           });
        }
      })
    
    },
    async biaoa () {
      if(this.vins!==''){
        let arri=this.vins.split(",")
        arri.forEach(zz=>{
           let params = 'searchValue=' + zz
            let a =1
            let b =0
      this.mation.forEach((e,i)=>{
        if(e.vin==zz){
           
             if(e.delFlag==1){
              b=i
              a=3
            }else{
                a=2
            }
        }
      })
      if(a==2){
         this.$message({
            message: '请勿重复添加车架号：'+zz,
             type: 'error'
            });

         return false
      }
      if(a==3){
          this.mation[b].imageData=[]
           this.mation[b].delFlag=0

            this.vin=''
           this.dialogVisible=false
            this.$message({
            message: '添加完成',
             duration:'1000'
            });
                let aac =this.mation
        this.matioonleng=0
        aac.forEach(e=>{
          if(e.delFlag!=='1'){
             this.matioonleng++
          }
        })
            return false
      }
      mcVehicleOfDealerLista(params).then(res => {
        if (res.data.code == 200) {
          if(res.data.total==0){
             this.$message({
            message: '未查询到车辆',
             type: 'error'
            });
            return false
          }
            if(res.data.rows[0].warrantyExpiry==null){
             this.$message({
            message: '该车辆未售出:'+res.data.rows[0].chassisNumber,
             type: 'error'
            });
            return false
          }
          let e =res.data.rows[0]
          let a ={
            mcSeriesModel:e.mcSeriesModel,
            vin:e.chassisNumber,
            currentWarrantyExpiry:e.warrantyExpiry,
            extendedWarrantyYear:'',//延长年限
            extendedWarrantyExpiry:'',//延长后年限
            imageData:[],//延长年限
            delFlag:'0'

          }
          this.mation.push(a)
         
            this.$message({
            message: '添加完成',
             duration:'1000'
            });
             let aac =this.mation
        this.matioonleng=0
        aac.forEach(e=>{
          if(e.delFlag!=='1'){
             this.matioonleng++
          }
        })
        }else{
           this.$message({
              message: 'tian',
             type: 'error'
           });
        }
      })
        })
            this.vins=''
           this.dialogVisiblea=false
      }
      
     
    
    },
  billTableRowClassName({ row, index }) {
  if (row.delFlag == '1') {
    return "hidden-row";  //隐藏
  }
  return ""  //显示
},
   
      dele(i){
        this.mation[i].delFlag='1'
        let a =this.mation
        this.matioonleng=0
        a.forEach(e=>{
          if(e.delFlag!=='1'){
             this.matioonleng++
          }
        })
       
      },

  }

};
</script>

<style lang="less" scoped>
::v-deep .el-table .hidden-row {
	display: none !important;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.cinput {
  width: 300px;
  margin-right: 10px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 10px;
  position: relative;


}

.bonntbota {
  position: absolute;
  right: 10px;
  top: 0;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.pop {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;

    .btn1 {
      width: 100px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-color: #409eff;
    }
  }

  .content {
    margin-bottom: 20px;
  }
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}
.cbjqq{
  margin-right: 10px;
  cursor: pointer;
  color: #409eff;
}
/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

.cctitle {
  color: #999999;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.btn {
  display: flex;
  justify-content: space-evenly;
  color: #31aff2;

  p {
    cursor: pointer;
  }
}

.title {
  padding-bottom: 10px;


  .status {
    display: flex;
    margin-top: 20px;

    div {
      margin-right: 25px;
      cursor: pointer;
    }
  }
}

.row-title {
  font-size: 18px;
  color: #222222;
  font-weight: 550;
}

.content-box {
  position: relative;
  background-color: #f2f2f2;
  border-radius: 10px;
  padding: 8px 4px;

  .qianshou {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>